import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DirectivesModule } from '@shared/directives/directives.module';
import {
  DvSplitterEventsService,
  DvSplitterResizableSide,
  DvVerticalSplitterComponent,
} from '@devinco/ui/dds/splitter';
import { RouterLink, RouterOutlet } from '@angular/router';
import { RouteNetworksGridComponent } from './components/route-networks-grid/route-networks-grid.component';
import { DvButtonComponent } from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  imports: [
    DirectivesModule,
    DvVerticalSplitterComponent,
    RouterOutlet,
    RouteNetworksGridComponent,
    DvButtonComponent,
    TranslateModule,
    RouterLink,
    UpperCasePipe,
  ],
  selector: 'app-route-network-page',
  templateUrl: './route-network-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../styles/page.scss'],
})
export class RouteNetworkPageComponent {
  private splitterEvents = inject(DvSplitterEventsService);

  resizableSide: typeof DvSplitterResizableSide = DvSplitterResizableSide;

  onCreateClick(): void {
    this.splitterEvents.isSplitterOpened$.next(true);
  }
}
